import { v4 as uuid } from 'uuid';
import { TagResponse, TagType } from 'services/api/responses/responseTypes';
import type { ITag } from './iTag';

export default class Tag implements ITag {
  id: string;

  name: string;

  active: boolean;

  type: TagType;

  queryValue: string | boolean;

  slug: string;

  constructor(data: TagResponse, type: TagType) {
    this.id = uuid();
    this.queryValue = data.id.toString();
    this.name = data.name;
    this.active = data.active;
    this.type = type;
    this.slug = this.createSlug();
  }

  // To be used as parameter/query string in URLs
  // Check this Pen for live slug generator: https://codepen.io/negarjf/full/VwjVRvV
  createSlug(): string {
    return this.name
      .replace(/\s+/g, '-')
      .replace(/&/g, 'and')
      .replace(/\//g, '-')
      .toLowerCase();
  }
}
